export default __webpack_public_path__ + "static/developmental_milestones-18c39889a9996c46caa2ce338b1de1fe.jpeg";